module.exports = __webpack_public_path__ + "i18n/es_c81a8091021816e5b0123c5e858af408.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 153